import script from "./base-multiselect.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-multiselect.vue?vue&type=script&setup=true&lang=ts"

import "./base-multiselect.vue?vue&type=style&index=0&id=53b3d1f1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b3d1f1"]])

export default __exports__